/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CaseUpdateControlCommandResult
 */
export interface CaseUpdateControlCommandResult {
	/**
	 *
	 * @type {string}
	 * @memberof CaseUpdateControlCommandResult
	 */
	url?: string | null;
}

/**
 * Check if a given object implements the CaseUpdateControlCommandResult interface.
 */
export function instanceOfCaseUpdateControlCommandResult(
	value: object
): value is CaseUpdateControlCommandResult {
	return true;
}

export function CaseUpdateControlCommandResultFromJSON(json: any): CaseUpdateControlCommandResult {
	return CaseUpdateControlCommandResultFromJSONTyped(json, false);
}

export function CaseUpdateControlCommandResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CaseUpdateControlCommandResult {
	if (json == null) {
		return json;
	}
	return {
		url: json['url'] == null ? undefined : json['url'],
	};
}

export function CaseUpdateControlCommandResultToJSON(json: any): CaseUpdateControlCommandResult {
	return CaseUpdateControlCommandResultToJSONTyped(json, false);
}

export function CaseUpdateControlCommandResultToJSONTyped(
	value?: CaseUpdateControlCommandResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		url: value['url'],
	};
}
